{
  "changeChain": {
    "title": "チェーンを選択"
  },
  "checkoutBlocked": {
    "notAvailable": "ご利用いただけません",
    "regionMessage": "このサービスはお住まいの地域ではご利用いただけません。",
    "viewRegions": "利用可能な地域を確認する。"
  },
  "common": {
    "addressCopied": "アドレスをコピーしました",
    "back": "戻る",
    "cancel": "キャンセル",
    "close": "閉じる",
    "confirm": "確認",
    "continue": "続ける",
    "copied": "コピーしました！",
    "copy": "コピー",
    "copyAddress": "アドレスをコピー",
    "done": "完了",
    "go": "開く",
    "loading": "読み込み中…",
    "ok": "OK",
    "poweredBy": "Powered by",
    "tryAgain": "再試行",
    "startOver": "最初からやり直す"
  },
  "depositAmount": {
    "amountLabel": "金額",
    "changeToMaximum": "最高額に変更",
    "changeToMinimum": "最低額に変更",
    "delete": "削除",
    "enterAmount": "金額を入力",
    "fee": "手数料 {{amount}}",
    "maximumAmount": "最高入金額 {{amount}}",
    "minimumAmount": "最低入金額 {{amount}}",
    "title": "入金",
    "submit": "入金",
    "submitWithMethod": "{{method}}で入金"
  },
  "feeDetails": {
    "amount": "金額",
    "fee": "手数料 {{rate}}",
    "summaryAddedToCharge": "{{method}} での入金には {{rate}} の手数料が発生し、請求総額に加算されます。",
    "summaryDeductedFromDeposit": "{{method}} での入金には {{rate}} の手数料が発生し、受取額から差し引かれます。",
    "title": "手数料の詳細",
    "totalCost": "合計金額",
    "youllGet": "受取額"
  },
  "fiat": {
    "agreeAndContinue": "規約に同意して続行",
    "amountLabel": "入金額",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Apple ウォレットにカードを追加してから、もう一度お試しください。",
    "applePayUnsupported": "この端末では Apple Pay で支払えません。",
    "blocked": "お住まいの地域では入金をご利用いただけません",
    "card": "カード",
    "contactVerifyBoth": "電話番号とメールアドレスを確認してください",
    "contactVerifyEmail": "メールアドレスを確認してください",
    "contactVerifyPhone": "電話番号を確認してください",
    "countryHeading": "お住まいの国",
    "countrySearchPlaceholder": "検索",
    "delete": "削除",
    "deposit": "入金",
    "depositReceived": "{{amount}} の入金を受け取りました",
    "depositReceivedFrom": "{{method}} から",
    "emailPlaceholder": "メールアドレス",
    "failure": "入金に失敗しました",
    "fee": "{{amount}}の手数料",
    "getNewPrice": "新しい価格を取得",
    "kycConsentCheck": "Fun による本人確認と、ご注文を処理する決済事業者への結果の共有に同意します。詳しくはこちら:",
    "kycConsentPrompt": "続行すると、Fun による本人確認と、ご注文を処理する決済事業者への結果の共有に同意したことになります。詳しくはこちら:",
    "kycConsentStop": "。",
    "kycDetailAddress": "ご住所をご入力ください",
    "kycDetailDob": "生年月日を入力してください",
    "kycDetailName": "ご入金を保護するため、本人確認の情報をもう少しお伺いします。",
    "kycDetailNationality": "国籍",
    "kycDetailOther": "残りの情報をご入力ください",
    "kycDetailSsn": "9桁のSSNをご入力ください",
    "kycFileUnsupported": "書類のアップロードは現在ご利用いただけません。近日中にこのステップを完了できるようになります。",
    "kycFormDetail": "初回の入金前に、いくつかの情報のご入力が必要です。",
    "kycFormInvalid": "入力内容の一部を確認してください。",
    "kycPhoneInUse": "この電話番号はすでに別の{{provider}}アカウントで使用されています。別の番号を入力してください。",
    "kycTaxIdInUse": "この納税者番号はすでに別の{{provider}}アカウントで使用されています。",
    "kycFormMissing": "必須項目が入力されていません。",
    "kycFormStale": "この手順が更新されました。以下の内容をご確認ください。",
    "kycFormTitle": "本人確認を行う",
    "kycIntroDetail": "アカウントの安全を保ちながら入金を処理するために必要です。1分ほどで完了し、本人確認書類は不要です。",
    "kycNoticeCountryCode": "AU のような2文字の国コードをご入力ください",
    "kycNoticeDateFormat": "YYYY-MM-DD の形式でご入力ください",
    "kycNoticeDatePast": "過去の日付をご入力ください",
    "kycNoticeInvalid": "ハイライトされた項目をご確認ください",
    "kycNoticeRequired": "ハイライトされた項目をご入力ください",
    "kycNoticeUnderage": "続行するには18歳以上である必要があります",
    "kycOnHold": "本人確認は保留中です",
    "kycOnHoldDetail": "後でもう一度お試しいただけます。",
    "kycOnHoldUntil": "{{date}} 以降に再度お試しいただけます。",
    "kycOpenLink": "本人確認を続ける",
    "kycOptional": "任意",
    "kycPrivacyPolicy": "プライバシーポリシー",
    "kycProviderGeneric": "決済事業者",
    "kycProviderGenericId": "当社の本人確認パートナー",
    "kycProviderTerms": "{{provider}}の利用規約",
    "kycProviderTermsPrompt": "続行すると、以下に同意したことになります:",
    "kycRejected": "本人確認が完了しませんでした",
    "kycRejectedSupport": "サポートにご連絡ください。確認いたします。",
    "kycRequired": "本人確認して入金",
    "kycRequiredCta": "本人確認が必要です →",
    "kycRequiredDetail": "入金を続けるには本人確認を完了してください。",
    "kycRequiredTitle": "本人確認が必要です",
    "kycCompleteDetail": "入金限度額が引き上げられました。",
    "kycCompleteTitle": "本人確認が完了しました",
    "kycHardCta": "オプションを見る →",
    "kycHardDetail": "本人確認による入金限度額の引き上げはできません。",
    "kycHardTitle": "本人確認ができません",
    "kycPendingCta": "確認の完了を待っています →",
    "kycPendingDetail": "できるだけ早く本人確認を完了できるよう対応しています。",
    "kycPendingTitle": "本人確認を処理中です",
    "kycSoftCta": "本人確認が必要です →",
    "kycSoftDetail": "内容を修正して、もう一度お試しいただけます。",
    "kycSoftTitle": "本人確認が完了できませんでした",
    "kycOptionCloseDetail": "一度終了して、後でこの入金に戻ることができます。",
    "kycOptionCloseTitle": "入金を閉じる",
    "kycOptionMaxDetail": "本人確認の前は {{max}} まで。",
    "kycOptionMaxDetailUnknown": "本人確認の前は現在の限度額まで。",
    "kycOptionMaxTitle": "上限まで入金",
    "kycOptionRedoDetail": "情報と書類をご確認のうえ、もう一度お試しください。",
    "kycOptionRedoTitle": "本人確認をやり直す",
    "kycOptionSupportDetail": "本人確認の要件に関する問題については、お問い合わせください。",
    "kycOptionSupportTitle": "ヘルプとサポート",
    "kycOptionsHardTitle": "本人確認後も入金限度額を引き上げることができません。",
    "kycOptionsLabel": "現在できること:",
    "kycOptionsPendingTitle": "本人確認をまだ処理中です。入金限度額はまだ変更されていません。",
    "kycOptionsSoftTitle": "本人確認が完了できませんでした。前回の内容を修正して、もう一度お試しください。",
    "kycTitle": "本人確認",
    "otpDetailAnyEmail": "コードをメールアドレスに送信しました",
    "otpDetailAnyPhone": "コードを電話番号に送信しました",
    "otpDetailEmail": "{{email}} にコードを送信しました",
    "otpDetailPhone": "{{phone}} にコードを送信しました",
    "otpError": "そのコードは無効でした。確認して再試行してください。",
    "otpExpired": "コードの有効期限が切れました。新しいコードをリクエストしてください。",
    "otpRateLimited": "コードのリクエスト回数が多すぎます。しばらく待ってからもう一度お試しください。",
    "otpRateLimitedTitle": "次のコードをリクエストするまでお待ちください",
    "otpPlaceholder": "6桁のコード",
    "otpResend": "再送信",
    "otpResendPrompt": "コードが届きませんか？",
    "otpTitle": "コードを入力",
    "payButton": "Apple Payで入金",
    "paySheetPay": "支払う",
    "paySheetTitle": "Apple Payで確認",
    "paySheetTotal": "合計 {{amount}}",
    "phoneCountryLabel": "国番号",
    "phoneCountrySearch": "国を検索",
    "phonePlaceholder": "電話番号",
    "processing": "入金を処理中…",
    "pendingOrderTitle": "未完了の入金があります",
    "pendingOrderDetail": "{{amount}}の入金を再開するか、キャンセルして新しい金額で続行してください。",
    "resumeDeposit": "入金を再開",
    "cancelDeposit": "入金をキャンセル",
    "quoteExpired": "この価格は期限切れです",
    "quoteFailed": "価格を取得できませんでした",
    "redirectDetail": "お戻りになりましたら、この画面を更新します。",
    "redirectReopen": "ブラウザをもう一度開く",
    "redirectTitle": "ブラウザでお支払いを完了してください",
    "refunded": "入金を返金しました",
    "refusalDetails": "入力内容を確認して、もう一度お試しください。",
    "refusalDetailsTitle": "一部の情報を再確認してください",
    "refusalLimits": "少ない金額か、別のお支払い方法をお試しください。",
    "refusalLimitsTitle": "このお支払い方法ではその金額を扱えません",
    "refusalUnavailable": "こちら側の問題です。しばらくしてからもう一度お試しいただくか、少ない金額をお試しください。",
    "refusalUnavailableTitle": "現在ご利用いただけるお支払い方法がありません",
    "requote": "新しい見積もりを取得",
    "reviewTitle": "入金内容を確認",
    "orderConfirmingTitle": "お支払いを確認しています",
    "orderConfirmingDetail": "お支払いは完了しました。入金を記録しています。少しお待ちください。",
    "submitFailed": "送信できませんでした",
    "paymentFailed": "もう一度お試しください",
    "submitting": "送信中",
    "stripeAuthDetail": "{{email}} を使用して Link で安全に続行します。",
    "stripeAuthorizing": "Stripe で続行",
    "stripeAuthorizingDetail": "Stripe の画面で Link の認証と同意を完了してください。",
    "stripeAuthTitle": "Stripe で続行",
    "stripeAuthFailed": "Stripeセッションを開始できませんでした。もう一度お試しください。",
    "stripeKycInfoFailed": "Stripe に情報を保存できませんでした。入力内容を確認してもう一度お試しください。",
    "stripeRegistrationFailed": "Link アカウントを作成できませんでした。入力内容を確認してもう一度お試しください。",
    "success": "入金が完了しました",
    "successDetail": "残高はまもなく更新されます。",
    "termsNotice": "続行すると、プロバイダーの\n<terms>利用規約</terms>に同意したことになります。",
    "unsupported": "このステップはまだご利用いただけません",
    "verifying": "本人確認を行っています…",
    "verifyingDetail": "通常1分もかかりません。",
    "verifyingSlow": "確認を続けています",
    "verifyingSlowDetail": "いったん閉じて、少し後にご確認ください。",
    "coinbaseTermsNotice": "続行すると、Coinbaseの\n<terms>利用規約</terms>、<agreement>ユーザー契約</agreement>、<privacy>プライバシーポリシー</privacy>に同意したことになります。",
    "contactInvalidEmail": "有効なメールアドレスを入力してください",
    "kycIntroTitle": "本人確認を始めましょう",
    "kycAdditionalTitle": "もう少し情報が必要です",
    "kycAdditionalDetail": "入金限度額を引き上げるには、追加の本人確認が必要です。確認が完了すると、引き上げられた限度額をすぐにご利用いただけます。",
    "kycFindOutMore": "詳細を見る",
    "kycR2Consent": "続行すると、Funが本人確認を行い、その結果を指定の決済サービス提供者と共有することに同意したものとみなされます。",
    "kycAgreeContinue": "同意して続行",
    "kycSsnLastFour": "SSNの下4桁を\n入力してください",
    "kycSsnProtection": "米国の法律により、本人確認のためにSSNを収集する必要があります。お客様の情報は銀行水準の暗号化で保護されています。",
    "kycDetailCountry": "居住国",
    "kycCountry": "国",
    "kycDetailOccupation": "ご職業",
    "kycDetailPurpose": "取引の目的を教えてください",
    "kycOccupation": "職業",
    "kycPurpose": "取引の目的",
    "kycDetailPhone": "携帯電話番号",
    "kycDetailEmployment": "雇用状況",
    "kycDetailSourceOfWealth": "資産の出所",
    "kycDetailIncome": "年間総収入",
    "kycDetailActivity": "毎月の利用状況",
    "kycIncomeCaption": "税引き前、現地通貨で",
    "kycReviewTitle": "ありがとうございます。情報を受け取り、現在確認しています。",
    "kycHoldTitle": "ありがとうございます。情報を受け取りました。確認の完了までもう少しお時間をいただきます。",
    "kycRestrictedTitle": "アカウントが制限されています。",
    "regionUnsupportedTitle": "お住まいの地域はサポートされていません。",
    "kycAnyQuestions": "ご質問はありますか？",
    "kycGetHelpSupport": "ヘルプとサポート",
    "otpVerified": "コードを確認しました",
    "authConnectFailedTitle": "{{provider}}アカウントに接続できませんでした",
    "authConnectFailedDetail": "最初からやり直してサインインしてください。",
    "kycUnavailableTitle": "現在、本人確認をご利用いただけません。",
    "kycUnavailableNetwork": "少し待って再試行するか、後でもう一度お試しください。",
    "kycUnavailableProviderTitle": "本人確認を完了できませんでした。",
    "kycUnavailableProvider": "当社側で問題が発生しました。サポートにご連絡ください。担当者が対応いたします。",
    "contactSupport": "サポートに連絡",
    "kycDocumentTitle": "本人確認書類の認証",
    "kycDocumentDetail": "本人確認を完了するため、身分証の確認が必要です。本人確認は{{provider}}が提供しています。",
    "kycDocumentContinue": "{{provider}}で本人確認",
    "applePayUnavailableTitle": "Apple Payは一時的に利用できません。",
    "kycLimitNotice": "1日の上限に達しました。今すぐ本人確認を行うと、上限額をすぐに引き上げられます。",
    "contactEmailRejected": "このメールアドレスは確認できません。別のアドレスを選択してください。",
    "contactReverifyPhone": "電話番号をもう一度確認してください。",
    "coinbaseCardSoftDeclined": "銀行がこの支払いを拒否しました。Apple Pay で別のカードを試すか、銀行にお問い合わせください。",
    "coinbaseCardHardDeclined": "銀行がこのカードを拒否しました。Apple Pay で別のカードをご利用ください。",
    "coinbaseCardRiskDeclined": "この支払いは承認されませんでした。Apple Pay で別のカードをお試しください。",
    "coinbaseInvalidCard": "Apple Pay のカードと請求先住所をご確認のうえ、もう一度お試しください。",
    "coinbaseInsufficientBalance": "このカードでは入金額に対して残高が不足しています。",
    "coinbasePrepaidCard": "プリペイドカードはご利用いただけません。Apple Pay でデビットカードをご利用ください。",
    "coinbaseRegionUnsupported": "お住まいの地域ではカードでの入金をご利用いただけません。",
    "coinbasePermissionDenied": "このお支払い方法はお客様のアカウントではご利用いただけません。",
    "coinbaseWeeklyLimit": "週あたりのカード入金上限を超えます。金額を減らしてお試しください。",
    "coinbaseLifetimeCount": "Coinbase アカウントなしでご利用いただけるカード入金の回数を使い切りました。",
    "coinbaseDailyCount": "本日のカード入金の上限に達しました。明日もう一度お試しください。",
    "coinbaseBillingZip": "請求先の郵便番号がカードと一致しません。ご確認のうえ、もう一度お試しください。",
    "coinbaseBillingAddress": "請求先住所が不完全です。ご確認のうえ、もう一度お試しください。",
    "coinbaseBillingName": "カード名義が受け付けられませんでした。ご確認のうえ、もう一度お試しください。",
    "coinbaseSessionExpired": "この支払いセッションは期限切れです。入金をやり直してください。",
    "coinbaseNetworkUnsupported": "お住まいの地域ではこのネットワークをご利用いただけません。",
    "coinbaseAssetUnsupported": "お住まいの地域ではこのトークンをご利用いただけません。",
    "coinbaseProviderError": "Coinbase 側で処理を完了できませんでした。しばらくしてからもう一度お試しください。",
    "coinbaseBuyFailed": "購入を完了できませんでした。カードへの請求は行われていません。",
    "coinbaseSendFailed": "入金をお届けできませんでした。カードへ返金されます。",
    "coinbaseAvsFailed": "請求先住所を確認できませんでした。銀行にご確認のうえ、もう一度お試しください。",
    "cancelled": "入金がキャンセルされました",
    "sessionExpired": "セッションが期限切れです。もう一度サインインして入金を続けてください。",
    "accountIneligibleTitle": "このアカウントでは入金をご利用いただけません",
    "accountIneligibleDetail": "誤りだと思われる場合はサポートにお問い合わせください。"
  },
  "fops": {
    "bankTransferSubtitle": "限度額 {{limit}}・1〜2日",
    "bankTransferTime": "1〜2日",
    "instant": "即時",
    "limit": "限度額 {{limit}}"
  },
  "networks": {
    "chainFallback": "チェーン {{chainId}}",
    "minimum": "最低 ${{min}}"
  },
  "qrCode": {
    "title": "QRコード"
  },
  "selectChain": {
    "subtitle": "入金元のネットワークを選択",
    "title": "暗号資産を入金"
  },
  "selectMethod": {
    "crypto": "暗号資産",
    "depositTo": "入金先",
    "errorMessage": "データの読み込みに問題が発生しました。\nインターネット接続を確認して再試行してください。",
    "errorTitle": "問題が発生しました",
    "loadingMethods": "支払い方法を読み込み中",
    "noLimit": "制限なし",
    "payWith": "支払い方法",
    "title": "入金"
  },
  "selectReceiveToken": {
    "availableTokens": "利用可能なトークン",
    "moreTokens_other": "+{{count}} トークン",
    "searchTokens": "トークンを検索",
    "selectChain": "チェーンを選択",
    "selectToken": "トークンを選択",
    "title": "受取トークンとチェーン"
  },
  "transferCrypto": {
    "changeChain": "チェーンを変更",
    "depositAddressLabel": "あなたの入金アドレス",
    "generating": "生成中…",
    "selectedChain": "選択中のチェーン",
    "share": "共有",
    "shareAddress": "アドレスを共有",
    "showQrCode": "QRコードを表示",
    "title": "暗号資産を送金"
  },
  "withdraw": {
    "belowMinimumMessage": "残高が現金出金の最低額を下回っています。",
    "belowMinimumTitle": "残高不足",
    "cashMethodsError": "現金の出金方法を読み込めませんでした。暗号資産での出金は可能です。",
    "noCashMethods": "銀行やカードでの出金はお住まいの地域では利用できません。暗号資産での出金は可能です。",
    "title": "出金",
    "unavailableMessage": "現金出金は現在お住まいの地域ではご利用いただけません。",
    "unavailableTitle": "出金はご利用いただけません"
  },
  "withdrawAddress": {
    "breakdown": "受取額は約 {{amount}} です。ネットワークの状況によって多少変動する場合があります。この取引が {{minimum}} を下回る価格で実行されることはありません。数秒で完了する見込みです。",
    "breakdownTitle": "取引の内訳",
    "clear": "クリア",
    "detected": "ウォレットを検出しました",
    "notFound": "ウォレットが見つかりません",
    "paste": "貼り付け",
    "requested": "出金をリクエストしました",
    "title": "{{amount}} を出金",
    "useConnected": "接続中のウォレットを使う",
    "withdrawNow": "今すぐ出金",
    "withdrawing": "出金中",
    "withdrew": "出金しました",
    "youllReceive": "受取額"
  },
  "withdrawAmount": {
    "amountLabel": "金額",
    "delete": "削除",
    "swapDenomination": "ドルとトークンを切り替える",
    "useMax": "全額を使う"
  },
  "withdrawCrypto": {
    "aboveBalance": "残高不足",
    "addressPlaceholder": "ウォレットアドレス",
    "available": "利用可能: {{amount}} {{symbol}}",
    "belowFee": "金額は手数料 {{amount}} より大きくしてください",
    "belowMinimum": "最小金額は{{amount}}です",
    "ctaInvalidForChain": "このネットワークでは無効なアドレスです",
    "ctaMaxExceeded": "上限金額を超えています",
    "ctaRecipientSameAsSource": "別のアドレスを選択してください",
    "ctaSelectDestination": "送金先を選択",
    "errorGeneric": "出金に失敗しました。再試行してください。",
    "errorInsufficientGas": "ガスが不足しています。",
    "errorSwitchChain": "ネットワークを切り替えられません。ウォレットがそのネットワークに対応しているか確認してください。",
    "failedMessage": "{{amount}} は受取人に届きませんでした。資金が戻らない場合はサポートにご連絡ください。",
    "failedTitle": "出金が完了しませんでした",
    "max": "最大",
    "methodSubtitle": "上限なし",
    "methodTitle": "暗号資産アドレス",
    "quoteFailed": "スワップ見積もりの取得に失敗しました。もう一度お試しください。",
    "receiveAs": "受取通貨",
    "refundedMessage": "{{amount}} はウォレットに返金されました。",
    "riskyAddress": "制限により、このウォレットアドレスは使用できません。",
    "selectSource": "送金元を選択",
    "sendFrom": "出金元",
    "successPendingMessage": "{{amount}} はオンチェーンで処理中です。閉じても問題ありません。",
    "successPendingTitle": "出金を送信しました",
    "title": "暗号資産を出金",
    "unsupportedRecipient": "サポートされていない受取アドレス"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}}時間",
    "delayHoursMinutes": "{{hours}}時間{{minutes}}分",
    "delayMinutes": "{{minutes}}分",
    "delaySecond": "1秒",
    "delaySeconds": "{{seconds}}秒",
    "fastDisclaimer": "USDCパープスのみ · 複数チェーン · 即時",
    "fastDisclaimerUnified": "USDCのみ · 複数チェーン · 即時",
    "methodFast": "高速",
    "methodSecure": "ネイティブブリッジ",
    "secureDisclaimer": "全トークン · イーサリアムチェーンのみ · {{delay}}",
    "secureFallbackDelay": "60分以上"
  },
  "withdrawNado": {
    "errorAmountTooLow": "金額が少なすぎて Nado の出金手数料を支払えません。",
    "errorBalanceChanged": "出金可能残高が変わりました。「最大」を押して再試行してください。",
    "errorInvalidNonce": "この出金リクエストは期限切れです。再試行してください。",
    "errorNetwork": "現在 Nado に接続できません。再試行してください。",
    "errorNoPriorDeposit": "出金する前に Nado へ入金してください。",
    "errorRateLimited": "リクエストが多すぎます。しばらく待ってから再試行してください。",
    "errorSignerMismatch": "出金するには、この Nado アカウントを所有するウォレットに切り替えてください。",
    "errorUnconfirmed": "出金を確認できませんでした。再試行する前に Nado の残高をご確認ください。",
    "errorWithdrawRisk": "Nado の 24 時間出金上限に達しました。後でもう一度お試しください。"
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "カード"
  },
  "lockedTransfer": {
    "amountInfoTitle": "送金額",
    "amountInfoDescription": "{{amount}}を入金するために送金する金額です。この金額を超えて送金された資金は入金されず、回収にはサポートへの連絡が必要です。",
    "amountLoading": "計算中…",
    "amountUnavailable": "金額を取得できません",
    "title": "暗号資産を入金",
    "send": "送信",
    "amount": "金額",
    "address": "一度限りの入金アドレス",
    "copyAmount": "金額をコピー",
    "amountCopied": "金額をコピーしました",
    "showFullAddress": "アドレス全体を表示",
    "tokenOnChain": "{{chain}}の{{token}}"
  },
  "selectAsset": {
    "emptyChains": "対応するネットワークがありません",
    "combinedTitle": "送信するトークンとネットワーク",
    "title": "資産を選択",
    "empty": "利用可能な対応資産はありません"
  }
}
